import { createSelector, createSlice } from "@reduxjs/toolkit";

const prospectsSlice = createSlice({
    name: "prospects",
    initialState: {
        userList: { data: [], attendance: [] },
        prospects: [],
        currentProspect: null,
        saving: false,
        fetching: false,

    },
    reducers: {
        listUsers: () => { },
        storeUser: (state, action) => {
            //console.log({ dd: action.payload })
            state.userList = action.payload
        },
        createProspects: () => { },
        appendProspects: (state, action) => {
            state.prospects.push(action.payload)
        },
        getCurrentProspect: (state) => { state.fetching = true },
        updateProspect: (state) => {
            state.saving = true
        },
        getMontlyReport: (state) => { },
        storeMonthlyReport: (state) => { },
        storeCurrentProspect: (state, action) => {
            state.saving = false
            state.fetching = false
            state.currentProspect = action.payload;
        },
        getAllProspectList: () => { },
        getProspectList: () => { },
        getTrashProspects: () => { },
        removeTrashProspects: () => { },
        restoreTrashProspects: () => { },
        storeTrashProspects: () => { },
        storeProspectList: (state, action) => {
            state.prospects = action.payload;
        },
        clearSaving: (state) => {
            state.saving = false
            state.fetching = false
        },
        removeProspect: () => { },
        removeProspectFromList: (state, action) => {
            const d = state.prospects.filter(d => d?._id !== action.payload._id);
            state.prospects = d
        },

        clearAllProspects: (state) => {
            state.userList = { data: [], attendance: [] }
            state.currentProspect = null;
            state.prospects = [];
            state.saving = false;
            state.fetching = false
        }
    }
});

export const {
    storeUser,
    listUsers,
    getMontlyReport,
    storeMonthlyReport,
    restoreTrashProspects,
    removeTrashProspects,
    getTrashProspects,
    storeTrashProspects,
    appendProspects,
    createProspects,
    getCurrentProspect,
    getProspectList,
    getAllProspectList,
    storeCurrentProspect,
    storeProspectList,
    removeProspect,
    removeProspectFromList,
    updateProspect,
    clearSaving,

    clearAllProspects
} = prospectsSlice.actions;

export const prospectSelector = createSelector(
    state => state.prospects,
    prospects => prospects
);

export default prospectsSlice.reducer;